import {
  AxiosHeaders,
  AxiosRequestConfig,
  AxiosRequestHeaders,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { ParticipantData } from "../models/Participant";
import apiClient, { requiresAuth } from "./apiClient";

export interface ParticipantResponse {
  participants: ParticipantData[];
  totalCount: number;
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

class ParticipantService {
  async editParticipant (
    participantId: string,
    participant: ParticipantData
  ) {
    const response = await apiClient.patch(
      `/participants/${participantId}`,
      { participant },
      requiresAuth()
    );
    return response.data;
  };

  async getParticipantById (participantId: string) {
    const response = await apiClient.get(
      `/participants/${participantId}`,
      requiresAuth()
    );
    return response.data;
  };

  async getAllParticipants (
    page?: number,
    limit?: number,
    sortBy?: string,
    sortOrder?: string,
    search?: string
  ): Promise<ParticipantResponse> {
    const params: Record<string, string | number> = {
      ...(page !== undefined && { page }),
      ...(limit !== undefined && { limit }),
      ...(sortBy && { sortBy }),
      ...(sortOrder && { sortOrder }),
      ...(search && { search }),
    };

    const headers = new AxiosHeaders({});
    const config: InternalAxiosRequestConfig = {
      headers: headers as AxiosRequestHeaders,
      params,
    };
    const authHeaders = requiresAuth(config);

    const response: AxiosResponse<ParticipantResponse> = await apiClient.get(
      `/participants`,
      authHeaders
    );
    return response.data;
  };

  async getIfParticipantIsRegisteredForCourse (participantEmail: string, coursePassword: string) {
    try {
      const response = await apiClient.get(
        `/participants/${participantEmail}/courses/${coursePassword}`,
        requiresAuth()
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching courses for participant:", error);
      throw error;
    }
  }
}

export default new ParticipantService();
